module.exports = __webpack_public_path__ + "images/emoji/hamburger.71e70e1c55ae5c930ece.png";